import { render, staticRenderFns } from "./RecColumnSearchMenu.vue?vue&type=template&id=3cd7e4c8&scoped=true"
import script from "./RecColumnSearchMenu.vue?vue&type=script&lang=js"
export * from "./RecColumnSearchMenu.vue?vue&type=script&lang=js"
import style0 from "./RecColumnSearchMenu.vue?vue&type=style&index=0&id=3cd7e4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd7e4c8",
  null
  
)

export default component.exports